import { render, staticRenderFns } from "./WebinariDani15.vue?vue&type=template&id=4663b85d&scoped=true&"
import script from "./WebinariDani15.vue?vue&type=script&lang=js&"
export * from "./WebinariDani15.vue?vue&type=script&lang=js&"
import style1 from "./WebinariDani15.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4663b85d",
  null
  
)

export default component.exports